import { ContentfulSysType } from './contentful-sys.type';

export interface ContentfulEntryInterface {
  sys: ContentfulSysType;
  fields: any;
  includes: {
    Entry: Object[];
    Asset: Object[]
  };
}

export abstract class ContentfulEntryType implements ContentfulEntryInterface {
  sys: ContentfulSysType;
  fields: any;
  includes: {
    Entry: Object[];
    Asset: Object[]
  };

  constructor(entry: ContentfulEntryInterface, includes?: { Entry: Object[], Asset: Object[]}) {
    this.sys = entry.hasOwnProperty('sys') ? entry.sys : null;
    this.fields = entry.hasOwnProperty('fields') ? entry.fields : null;
    this.includes = entry.includes ? entry.includes : includes ? includes : null;
  }
}
